module.exports = __webpack_public_path__ + "static/media/8.Dewatering-Pump.04006056.webp";